export const isVideoType = (s) => ['video', 'playlist'].includes(s);
//# sourceMappingURL=videoPlayerTypes.js.map